import React from 'react';
import { Container, Row, Col, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

const Header = () => {
  const navigate = useNavigate();
  
  const handleAdminLogin = () => {
    navigate('/admin');
  };
  
  const handleHomeClick = () => {
    navigate('/');
  };
  return (
    <div className="university-header bg-white py-3 border-bottom shadow-sm">
      <Container>
        <Row className="align-items-center">
          {/* University Logo */}
          <Col xs={3} md={2} className="text-center pe-0 me-n3">
            <div className="university-logo">
              <img 
                src="/SRTMUN_Logo_Official_Black.png" 
                alt="SRTMU Logo" 
                style={{width: '80px', height: '80px', objectFit: 'contain'}}
                className="img-fluid"
              />
            </div>
          </Col>
          
          {/* University Name and Details */}
          <Col xs={6} md={8} className="px-1 text-center">
            <div className="university-info">
              <h4 className="mb-1" style={{color: '#ff6600', fontWeight: 'bold', fontSize: '1.2rem'}}>
                स्वामी रामानंद तीर्थ मराठवाडा विद्यापीठ, नांदेड
              </h4>
              <h5 className="mb-1" style={{color: '#ff6600', fontWeight: 'bold', fontSize: '1.1rem'}}>
                Swami Ramanand Teerth Marathwada University, Nanded
              </h5>
              <p className="mb-1 small text-muted">
                Recognized by the UGC U/s 2(f) and 12(B) NAAC Re-accredited 'B++' grade with CGPA 2.96
              </p>
              <p className="mb-0 small" style={{color: '#ff6600'}}>
                University AISHE Code:-U0328
              </p>
            </div>
          </Col>
          
          {/* Founder Image */}
          <Col xs={3} md={2} className="text-center ps-0 ms-n3">
            <div className="founder-image">
              <img 
                src="/swami-ramanand.jpg" 
                alt="Swami Ramanand" 
                style={{width: '80px', height: '80px', borderRadius: '50%', objectFit: 'cover'}}
                className="img-fluid border"
              />
            </div>
          </Col>
        </Row>
        
        {/* Navigation Buttons */}
        <div className="text-center mt-2">
          <Button 
            variant="outline-primary" 
            size="sm" 
            onClick={handleHomeClick}
            className="home-btn me-2"
          >
            <i className="bi bi-house-door me-1"></i>
            Home
          </Button>
          <Button 
            variant="outline-secondary" 
            size="sm" 
            onClick={handleAdminLogin}
            className="admin-btn"
          >
            <i className="bi bi-shield-lock me-1"></i>
            Admin Login
          </Button>
        </div>
      </Container>
    </div>
  );
};

export default Header;
